import { z } from 'zod';
export const EmMarkSchema = z.object({
    type: z.literal('em')
});
export const StrongMarkSchema = z.object({
    type: z.literal('strong')
});
export const UnderlineMarkSchema = z.object({
    type: z.literal('underline')
});
export const LinkMarkAttributesSchema = z.object({
    href: z.string(),
    title: z.string().optional(),
    id: z.string().optional(),
    collection: z.string().optional(),
    occurrenceKey: z.string().optional()
});
export const LinkMarkSchema = z.object({
    type: z.literal('link'),
    attrs: LinkMarkAttributesSchema
});
export const MarkSchema = z.union([
    EmMarkSchema,
    LinkMarkSchema,
    StrongMarkSchema,
    UnderlineMarkSchema
]);
export const TextSchema = z.object({
    type: z.literal('text'),
    text: z.string(),
    marks: z.array(MarkSchema).optional()
});
export const HardBreakSchema = z.object({
    type: z.literal('hardBreak')
});
export const InlineNodeSchema = z.union([HardBreakSchema, TextSchema]);
export const BulletListSchema = z.object({
    type: z.literal('bulletList'),
    content: z.array(z.lazy(() => ListItemSchema))
});
/**
 * Represents heading attributes
 * https://developer.atlassian.com/cloud/jira/platform/apis/document/nodes/heading/#attributes
 *
 * @typedef HeadingAttributes
 * @property - level : represents depth of heading
 */
export const HeadingAttributesSchema = z.object({
    level: z.union([
        z.literal(1),
        z.literal(2),
        z.literal(3),
        z.literal(4),
        z.literal(5),
        z.literal(6)
    ])
});
export const HeadingSchema = z.object({
    type: z.literal('heading'),
    attrs: HeadingAttributesSchema,
    content: z.array(InlineNodeSchema).optional()
});
export const OrderedListAttributesSchema = z.object({
    order: z.number().optional()
});
export const OrderedListSchema = z.object({
    type: z.literal('orderedList'),
    content: z.array(z.lazy(() => ListItemSchema)),
    attrs: z.optional(OrderedListAttributesSchema)
});
export const ParagraphSchema = z.object({
    type: z.literal('paragraph'),
    content: z.array(InlineNodeSchema).optional()
});
export const ListItemSchema = z.object({
    type: z.literal('listItem'),
    content: z.array(z.union([BulletListSchema, OrderedListSchema, ParagraphSchema]))
});
export const RuleSchema = z.object({
    type: z.literal('rule')
});
export const TopLevelNodeSchema = z.union([
    BulletListSchema,
    HeadingSchema,
    OrderedListSchema,
    ParagraphSchema,
    RuleSchema
]);
export const ADFSchema = z.object({
    version: z.literal(1),
    type: z.literal('doc'),
    content: z.array(TopLevelNodeSchema)
});
//# sourceMappingURL=adf.js.map